import React from "react";

export default (props) => {
  return (
    <div>
      {props.content ? (
        <div
          dangerouslySetInnerHTML={{
            __html: props.content,
          }}
        />
      ) : (
        <h4 align="center">
          Template not loaded
          <br/>
          <br/>
        </h4>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevoV2/Texts/PatientElectronicText.js